import { Box, Typography } from '@mui/material';
import { ProductStockSubscriptionsDatagrid } from '../../components/DataGrid/ProductStockSubscriptions';

export const ProductStockSubscriptionsPage = () => {
  return (
    <Box p={3}>
      <Typography variant="h6" fontWeight={600} mb={1}>
        Product Stock Subscriptions
      </Typography>
      <Typography variant="body2" color="text.secondary" mb={3}>
        Out-of-stock products that customers have asked to be notified about. Once a product is back
        in stock and customers are notified, it is removed from this list.
      </Typography>
      <ProductStockSubscriptionsDatagrid />
    </Box>
  );
};
